import { useState } from'react';
import { Outlet, Link, useLocation } from'react-router-dom';
import { useTheme } from'../../hooks/useTheme';
import { KnowledgeNetworkFooter } from'../KnowledgeNetworkFooter';

export function Layout() {
 const location = useLocation();
 const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
 const { theme, resolvedTheme, toggleTheme } = useTheme();

 return (
 <div className="min-h-screen flex flex-col bg-white text-[#202122]">
 <a
 href="#main-content"
 className="sr-only focus:not-sr-only focus:absolute focus:top-0 focus:left-0 focus:z-[100] focus:px-4 focus:py-2 focus:bg-[#3366cc] focus:text-white focus:text-sm focus:font-medium"
 >
 Skip to main content
 </a>

 {/* Wikipedia-style header */}
 <header role="banner" className="sticky top-0 z-50 bg-white border-b border-[#a2a9b1] px-4 sm:px-6 py-3 flex items-center justify-between">
 <Link to="/" className="flex items-baseline gap-2" onClick={() => setMobileMenuOpen(false)}>
 <p className="text-xl font-serif font-bold tracking-tight text-[#202122]">
 Mercava Knowledge
 </p>
 </Link>

 {/* Desktop nav */}
 <nav role="navigation" className="hidden sm:flex items-center gap-1 text-sm font-sans">

 <Link
 key="/"
 to="/"
 className={`px-3 py-2 rounded text-sm transition-colors ${
 location.pathname ==='/'
 ?'text-[#3366cc] font-semibold bg-[#eaecf0]'
 :'text-[#54595d] hover:text-[#3366cc] hover:bg-[#f8f9fa]'
 }`}
 >
 Home
 </Link>
 <Link
 key="/demo"
 to="/demo"
 className={`px-3 py-2 rounded text-sm transition-colors ${
 location.pathname ==='/demo'
 ?'text-[#3366cc] font-semibold bg-[#eaecf0]'
 :'text-[#54595d] hover:text-[#3366cc] hover:bg-[#f8f9fa]'
 }`}
 >
 Explore the Chariot
 </Link>
 <button
 onClick={toggleTheme}
 className="ml-2 p-2.5 rounded text-[#54595d] hover:text-[#202122] hover:bg-[#f8f9fa] transition-colors min-h-[44px] min-w-[44px] flex items-center justify-center"
 aria-label="Toggle theme"
 title={`Theme: ${theme}`}
 >
 {resolvedTheme ==='dark' ? (
 <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
 <path strokeLinecap="round" strokeLinejoin="round" d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" />
 </svg>
 ) : (
 <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
 <path strokeLinecap="round" strokeLinejoin="round" d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z" />
 </svg>
 )}
 </button>
 </nav>

 {/* Mobile hamburger */}
 <button
 className="sm:hidden flex flex-col gap-1 p-3 min-w-[44px] min-h-[44px] rounded hover:bg-[#f8f9fa] transition-colors items-center justify-center"
 onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
 aria-label="Toggle menu"
 >
 <span className={`block w-5 h-0.5 bg-[#54595d] transition-transform duration-200 ${mobileMenuOpen ?'rotate-45 translate-y-[3px]' :''}`} />
 <span className={`block w-5 h-0.5 bg-[#54595d] transition-opacity duration-200 ${mobileMenuOpen ?'opacity-0' :''}`} />
 <span className={`block w-5 h-0.5 bg-[#54595d] transition-transform duration-200 ${mobileMenuOpen ?'-rotate-45 -translate-y-[3px]' :''}`} />
 </button>
 </header>

 {/* Mobile menu dropdown */}
 {mobileMenuOpen && (
 <div className="sm:hidden border-b border-[#a2a9b1] bg-white z-40">
 <nav role="navigation" className="flex flex-col px-4 py-2 gap-1 font-sans">

 <Link
 to="/"
 onClick={() => setMobileMenuOpen(false)}
 className={`block px-3 py-3 min-h-[44px] rounded text-sm transition-colors ${
 location.pathname ==='/'
 ?'text-[#3366cc] font-semibold bg-[#eaecf0]'
 :'text-[#54595d] hover:text-[#3366cc]'
 }`}
 >
 Home
 </Link>
 <Link
 to="/demo"
 onClick={() => setMobileMenuOpen(false)}
 className={`block px-3 py-3 min-h-[44px] rounded text-sm transition-colors ${
 location.pathname ==='/demo'
 ?'text-[#3366cc] font-semibold bg-[#eaecf0]'
 :'text-[#54595d] hover:text-[#3366cc]'
 }`}
 >
 Explore the Chariot
 </Link>
 <button
 onClick={() => { toggleTheme(); setMobileMenuOpen(false); }}
 className="flex items-center gap-2 px-3 py-3 min-h-[44px] rounded text-sm text-[#54595d] hover:text-[#202122] transition-colors"
 >
 {resolvedTheme ==='dark' ? (
 <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
 <path strokeLinecap="round" strokeLinejoin="round" d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" />
 </svg>
 ) : (
 <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
 <path strokeLinecap="round" strokeLinejoin="round" d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z" />
 </svg>
 )}
 Theme: {theme.charAt(0).toUpperCase() + theme.slice(1)}
 </button>
 </nav>
 </div>
 )}

 {/* Main Content */}
 <main id="main-content" role="main" className="flex-1">
 <Outlet />
 </main>

 {/* Footer */}
 <KnowledgeNetworkFooter />
 </div>
 );
}
